import { default as WscIconAnswer } from "./Answer";
import { default as WscIconAutoContent } from "./AutoContent";
import { default as WscIconBites } from "./Bites";
import { default as WscIconFilmChapter } from "./FilmChapter";
import { default as WscIconGraphic } from "./Graphic";
import { default as WscIconGraphicsAsset } from "./GraphicsAsset";
import { default as WscIconMoments } from "./Moments";
import { default as WscIconPbp } from "./Pbp";
import { default as WscIconQuestion } from "./Question";
import { default as WscIconSequence } from "./Sequence";
import { default as WscIconStory } from "./Story";
import { default as WscIconStream } from "./Stream";
import { default as WscIconVideo } from "./Video";
import { default as WscIconGlobeTime } from "./GlobeTime";
import { default as WscIconGameTime } from "./GameTime";

const icons = {
  WscIconAnswer,
  WscIconAutoContent,
  WscIconBites,
  WscIconFilmChapter,
  WscIconGraphic,
  WscIconGraphicsAsset,
  WscIconMoments,
  WscIconPbp,
  WscIconQuestion,
  WscIconSequence,
  WscIconStory,
  WscIconStream,
  WscIconVideo,
  WscIconGlobeTime,
  WscIconGameTime,
};

export default icons;
